// extracted by mini-css-extract-plugin
module.exports = {"section":"e3afc254ff--section--Qu2Kw","subtitle":"e3afc254ff--subtitle--ozKOY","ratings":"e3afc254ff--ratings--Surs1","rating":"e3afc254ff--rating--ooWPm"};